module.exports = __webpack_public_path__ + "img/icon3.0b1f0395.png";